import { defineComponent, ref } from 'vue';
import { close as closeIcon } from 'ionicons/icons';
import { IonButton, IonButtons, IonHeader, IonModal, IonTitle, IonToolbar, IonIcon } from "@ionic/vue";
import WebView from "@/components/WebView.vue";
import store from "@/store";
export default defineComponent({
    name: "HelpModal",
    components: {
        WebView,
        IonButton,
        IonButtons,
        IonToolbar,
        IonHeader,
        IonTitle,
        IonModal,
        IonIcon
    },
    setup() {
        const show = ref(false);
        const open = () => {
            show.value = true;
        };
        const close = () => {
            show.value = false;
            store.commit('setHelpModalShow', false);
        };
        const onWillDismiss = () => close();
        return {
            show,
            open,
            close,
            onWillDismiss,
            closeIcon
        };
    }
});
